import React from 'react';
import { createStyles, Container, Group, ActionIcon, rem, Text, Grid } from '@mantine/core';
import { IconBrandInstagram } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const useStyles = createStyles((theme) => ({
  footer: {
    marginTop: rem(120),
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    backgroundColor: '#0c0c0c', // Distinct dark shade
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    color: theme.white,
  },

  logo: {
    maxWidth: rem(200),

    [theme.fn.smallerThan('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  description: {
    marginTop: rem(5),

    [theme.fn.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
      textAlign: 'center',
    },
  },

  inner: {
    display: 'flex',
    justifyContent: 'space-between',

    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  groups: {
    display: 'flex',
    flexWrap: 'wrap',

    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  wrapper: {
    width: rem(160),
  },

  link: {
    display: 'block',
    color: theme.colors.gray[5],
    fontSize: theme.fontSizes.sm,
    paddingTop: rem(3),
    paddingBottom: rem(3),

    '&:hover': {
      textDecoration: 'underline',
      color: theme.white,
    },
  },

  title: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 700,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    marginBottom: `calc(${theme.spacing.xs} / 2)`,
    color: theme.white,
  },

  afterFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing.xl,
    paddingTop: theme.spacing.xl,
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',

    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },

  social: {
    [theme.fn.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
    },
  },
}));

const footerData = [
  {
    title: 'About',
    links: [
      { label: 'About Us', link: '/about' },
      { label: 'Contact Us', link: '/contact-us' },
    ],
  },
  {
    title: 'Policy',
    links: [
      { label: 'Terms & Conditions', link: '/terms-and-conditions' },
      { label: 'Privacy Policy', link: '/privacy-policy' },
      { label: 'Shipping Policy', link: '/shipping-policy' },
      { label: 'Cancellation Policy', link: '/cancellation-policy' },
    ],
  },
];

const Footer = () => {
  const { classes } = useStyles();

  const groups = footerData.map((group) => {
    const links = group.links.map((link, index) => (
      <Link key={index} className={classes.link} to={link.link}>
        {link.label}
      </Link>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Text size="xl" weight={700}>CDP3D</Text>
          <Text size="xs" color="dimmed" className={classes.description}>
            Your platform for custom 3D prints and models. Designed for creators, by creators.
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text color="dimmed" size="sm">
          © 2026 CDP3D. All rights reserved.
        </Text>

        <Group spacing={0} className={classes.social} position="right" noWrap>
          <ActionIcon size="lg" component="a" href="https://www.instagram.com/cdp_3d" target="_blank">
            <IconBrandInstagram size="1.05rem" stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
    </footer>
  );
}

export default Footer;